import React from 'react';
import { FaStar } from 'react-icons/fa';

const reviews = [
  {
    name: "Harsh Bardhan",
    institution: "BIT Mesra, CSE",
    rating: 5,
    feedback: "It was a great learning period with my mentor Ameta Divija ma'am. The curriculum was designed keeping all the students' schedule on priority basis. Thanks a lot for this opportunity."
  },
  {
    name: "Ananya Jana",
    institution: "Government College of Engineering and Leather Technology, IT",
    rating: 4,
    feedback: "It was my first Training and Internship program. I have learned many things from this. This interaction between InternsElite and me was very helpful and knowledgeable."
  },
  {
    name: "Raj Shekhar Singh",
    institution: "Lucknow University",
    rating: 4,
    feedback: "It was a great experience with Internselite which gave me an opportunity to do an internship with it. The internship program was very good and nice. Internselite was very helpful to me throughout my whole internship program."
  },
  {
    name: "Sankalp Nigam",
    institution: "Shri Jai Narayan Degree College, (KKC)",
    rating: 5,
    feedback: "The sessions are good. The information which is given in the sessions is helpful for my future works."
  },
  {
    name: "Bhoomika Deshmukh",
    institution: "Shaildevi Mahavidyalaya Anda, Durg CG (B.Ed.)",
    rating: 5,
    feedback: "The sessions went very smoothly. The guide explained everything to us in an easy way and the session after session, which was taken by the industrial professional, was also useful. It also proved to be very helpful. I would like to express my sincere thanks to the entire Internselite Guidance Group."
  },
  {
    name: "Kinjal Timbaliya",
    institution: "Government Engineering College Modasa, CS",
    rating: 4,
    feedback: "I have learned very much from this internship. I learned about Android Development and Flutter also. It was helpful for resume building, LinkedIn profile building, and improving interview skills. Thank you InternsElite Team for this opportunity."
  }
];

function Python_coding_Review_Program_Page() {
  return (
    <div>
      <div className='container'>
        <div className='row d-sm-block d-md-none'>
          <div className='col-md-1'></div>
          <div className='col-md-10'>
            <div className='text-center review_component_text'>
              <h2 className='display-5 pb-2'>Testimonial</h2>
              <p className='fs-6'>
                Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.
              </p>
            </div>
          </div>
          <div className='col-md-1'></div>
        </div>
        <div className='row'>
          <div className='col-md-4 pt-5'>
            <div className='Program_review_comp'>
              <div className='mt-5 px-5 review_component_text'>
                <h1 className='pt-5 display-6'>Hear What Our Students Say</h1>
                <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
              </div>
            </div>
          </div>
          <div className='col-md-8'>
            <div className='row'>
              {reviews.map((review, index) => (
                <div key={index} className={`col-md-${index % 2 === 0 ? 5 : 7} card`}>
                  <div className='card-body'>
                    <h5 className='font-weight-bold Review_not_copy'>{review.name}</h5>
                    <h6 className='font-weight-bold my-2 Review_not_copy'>{review.institution}</h6>
                    <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                      {[...Array(5)].map((_, starIndex) => (
                        <li key={starIndex}>
                          <FaStar color={starIndex < review.rating ? "gold" : "#e4e5e9"} />
                        </li>
                      ))}
                    </ul>
                    <p className='Review_not_copy'>
                      <i className='fas fa-quote-left pe-2'></i>{review.feedback}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Python_coding_Review_Program_Page;
